<template>
  <div>
    <a-time-unit-field
      :formLayout="formLayout"
      :size="size"
      :data="data"
      parentName="session_options"
      varName="session_expires"
      varVerbose="Session"
      :units="expire_units"
      :disabled="false"
    />
    <a-time-unit-field
      :formLayout="formLayout"
      :size="size"
      :data="data"
      parentName="session_options"
      varName="session_idle_expires"
      varVerbose="Idle Timeout"
    />
  </div>
</template>

<script>

export default {
  data() {
    return {
        idle_units: ['minutes', 'hours', 'days'],
        expire_units: ['minutes', 'hours', 'days', 'months']
    };
  },
  props: {
    formLayout: String,
    size: String,
    data: Object,
    options: Object
  }
};
</script>
